import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@/shared/ui';

export interface ArchivedAlertProps {
  /** Vlastní titulek; výchozí je lokalizovaný „Záznam je archivovaný". */
  title?: ReactNode;
  /** Vlastní popis; výchozí je lokalizovaný read-only text. */
  description?: ReactNode;
  /** Volitelná akce v pravé části banneru (např. tlačítko Obnovit). */
  action?: ReactNode;
  className?: string;
}

/**
 * Sdílený banner informující, že editovaná entita je archivovaná.
 * Znovupoužitelný napříč entitami (projekt, série, …).
 */
export function ArchivedAlert({ title, description, action, className }: ArchivedAlertProps) {
  const { t } = useTranslation('archival');

  return (
    <Alert
      severity="warning"
      title={title ?? t('banner.title')}
      action={action}
      className={className}
      data-testid="archived-alert"
    >
      {description ?? t('banner.description')}
    </Alert>
  );
}
